<template>
   <Catalog 
    v-if="category"
    :pageTitle="category.name"
    :category="category"
   />
</template>
<script setup lang="ts">
import Catalog from '~/components/templates/catalog.vue'

const route = useRoute();

const catalogService = useCatalogService();

const {
  data
} = await useAsyncData(
  `category-${route.params.slug}`,
  () => catalogService.getCategoryBySlug(route.params.slug as string),
  {
    default: () => ({ data: null }),
  }
)

const category = computed(() => data.value.data)

if (!category.value) {
  throw createError({ statusCode: 404, statusMessage: 'Category not found' });
}

definePageMeta({
  layout: 'shop'
})
</script>